import {
  MsalGuardConfiguration,
  MsalInterceptorConfiguration,
} from "@azure/msal-angular";
import {
  BrowserCacheLocation,
  InteractionType,
  IPublicClientApplication,
  PublicClientApplication,
} from "@azure/msal-browser";
import { environment } from "src/environments/environment";
export const MS_SCOPES = ["user.read", "Mail.Send", "Mail.ReadWrite"];
const env = environment.baseURL;

const isIE =
  window.navigator.userAgent.indexOf("MSIE ") > -1 ||
  window.navigator.userAgent.indexOf("Trident/") > -1;

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: "26c6ef84-3288-4fe6-b99a-91ea15abec9f",
      authority: "https://login.microsoftonline.com/common/",
      redirectUri: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage, // Better for security
      storeAuthStateInCookie: isIE, // Set to true for IE 11
    },
    system: {
      // tokenRenewalOffsetSeconds: 3540,
      tokenRenewalOffsetSeconds: 300,
    },
  });
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Popup,
    authRequest: {
      scopes: MS_SCOPES,
    },
  };
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string> | null>();
  // ONLY protect your actual API endpoints
  protectedResourceMap.set("https://graph.microsoft.com/v1.0/*", ["User.Read"]);
  protectedResourceMap.set(`${env}*`, MS_SCOPES);
  return {
    interactionType: InteractionType.Popup,
    protectedResourceMap,
  };
}
